const DragState = {
  NOT_DRAGGING: 'NOT_DRAGGING',
  DRAGGING: 'DRAGGING',
};

export default DragState;
